<template>
    <div>
        <g-loading v-show="first_loading" :full_view="false"></g-loading>
        <template v-if="!first_loading">
            <div v-for="(cart_item, index) in cart" class="product-blocks" :key="cart_item.id">
                <div class="product-block">
                    <a class="image-link" :href="item.href"><img :src="item.thumbnail" :alt="item.name"></a>
                    <div class="product-info">
                        <div class="title u-text-ellipsis has-2-lines">{{ item.name }}</div>
                        <div v-for="model in item.models" class="model u-text-ellipsis has-2-lines">{{ model.name }}</div>
                        <div class="labels">
                            <div class="c-label is-new" v-if="item.is_new">New</div>
                            <div class="c-label is-photos">写真集</div>
                            <div class="c-label is-up" v-if="item.is_pre_order == true">予約受付中</div>
                            <div class="c-label is-limited" v-if="item.extra">限定特典付</div>
                        </div>
                        <div class="u-place-bottom">
                            <span class="c-price-and-tax" :class="{'is-crossed pre-order-price_text-grey': crossOutPrice(item)}">
                                <span class="c-price_value">￥{{ cart_item.base_price_with_tax.toLocaleString() }}</span><span class="c-price_tax">（税込）</span>
                            </span>
                        </div>
                    </div>
                    <div class="product-price-detail">
                        <div>
                            <div v-if="cart_item.sales_discount.has_sale" class="price-grid">
                                <span>{{ cart_item.sales_discount.string }}</span>
                                <span class="c-label is-pink">{{ cart_item.sales_discount.value }}OFF</span>
                                <span class="price">－￥{{ cart_item.sales_discount.amount }}</span>
                            </div>
                            <div v-if="cart_item.plus_discount.has_discount" class="price-grid">
                                <span>{{ cart_item.plus_discount.string }}</span>
                                <span class="c-label is-orange">{{ cart_item.plus_discount.value }}OFF</span>
                                <span class="price">－￥{{ cart_item.plus_discount.amount }}</span>
                            </div>
                            <div v-if="false" class="price-grid coupon">
                                <span>
                                    <div class="u-mb-2">クーポン利用</div>
                                    <custom_coupon_list
                                        class="custom-coupon-list"
                                        :ref="'couponList' + index"
                                        :route_list="route_list"
                                        :user_data="user_data"
                                        :user_coupon_list="user_coupon_list"
                                        :selected_code="selected_coupon"
                                        :item_hash="item['hash']"
                                        :index="index"
                                        :status="coupon_list_status[index]"
                                        @changeCoupon="changeCoupon"
                                        @openList="openList"
                                        :is_logged_in="true"
                                    ></custom_coupon_list>
                                    <div v-if="cart_item.coupon_discount.error"> {{ cart_item.coupon_discount.error }}</div>
                                </span>
                                <span class="price">－￥{{ cart_item.coupon_discount.amount.toLocaleString() }}</span>
                            </div>
                            <div class="price-grid">
                                <span>
                                    <div>消費税</div>
                                    <div v-if=" cart_item.tax_error">{{ cart_item.tax_error }}</div>
                                </span>
                                <span></span>
                                <span class="price">￥{{ cart_item.tax }}</span>
                            </div>
                        </div>
                        <div class="total-block">
                            <div class="text">小計（税込）</div>
                            <div class="total-price">￥{{ cart_item.total }}</div>
                        </div>
                        <div class="delete-button-container">
                            <a class="delete-button" :href="item.href">この商品を削除</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 以下は、全体クーポンの機能に対応したらコメントアウトを外す -->
            <div v-if="false" class="coupon-block">
                <div class="add-coupon">
                    <div class="add-form">
                        <p class="note">キャンペーン用のクーポンコードをお持ちの場合、<br>フォームにコードを入力して下さい。</p>
                        <input type="text" v-model="input_coupon_code" class="browser-default c-input-text" placeholder="クーポンコードを入力" />
                        <a class="c-round-btn is-positive is-bg-white" @click="couponActivate"><span><span class="when-sp">クーポン</span><span>追加</span></span></a>
                        <span v-show="error_coupon_activate">{{ error_coupon_activate }}</span>
                    </div>
                </div>
                <!-- <div class="all-coupon">
                    <div class="title">全体クーポン</div>
                    <p class="note is-pc">キャンペーン用のクーポンコードをお持ちの場合、フォームにコードを入力して下さい。</p>
                    <div>TODO: 全体クーポンを表示</div>
                </div> -->
            </div>
            <div class="link-buttons">
                <slot></slot>
            </div>
            <coupon_modal v-show="show_modal" ref="coupon_activate_modal"
                :title="modal_title"
                :message=modal_message
                :has_back="modal_has_back"
                :show_message_modal="show_message_modal"
                @back_button="checkBackAction"
                :cancel_button="modal_cancel_button ? '他の決済方法を選択する' : '戻る'"
                @closing ="closeModal"
            >
            </coupon_modal>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import routeMixin from '../../../mixins/route.js';
import coupon_modal from '../../../components/coupon/MessageModal.vue';
import custom_coupon_list from '../../cart/customCouponList.vue';

export default {
    mixins: [routeMixin],
    props: [
        'route_list',
        'user_data',
        'item',
        'set_coupon_code',
        'category',
    ],
    components: {
        custom_coupon_list,
        coupon_modal,
    },
    data() {
        return {
            cart : [],
            user_coupon_list : [],
            coupon_list_status: [],
            first_loading: true,
            item_detail: {},
            is_loading: {
                coupon: true,
                price: true,
            },
            input_coupon_code : "",
            error_coupon_activate : "",
            show_coupon_modal: false,
            modal_title: "",
            modal_message: "",
            modal_has_back: false,
            selected_coupon: '',
            show_modal: true,
            modal_cancel_button: null,
            show_message_modal: false,
        }
    },
    created() {
        // ユーザーのカート取得
    },
    mounted: function() {
        this.selected_coupon = this.set_coupon_code;
        this.getCartItems(true);
    },
    computed: {
        items_amount() {
            if(this.item) {
                return this.item.length;
            }
            return 0;
        },
        total_price: function() {
            let price = 0;
            if (this.items_amount) {
                this.cart.forEach(function(value, index) {
                    price += value.total;
                })
            }
            return price;
        },
        total_tax: function() {
            let tax = 0;
            if (this.items_amount) {
                this.cart.forEach(function(value, index) {
                    tax += value.tax;
                })
            }
            return tax;
        },
        total_price_without_tax: function() {
            let price = 0;
            if (this.items_amount) {
                this.cart.forEach(function(value, index) {
                    price += value.price;
                })
            }
            return price;
        },
    },
    watch: {
        cart: {
            handler() {
                this.total_price;
                this.total_tax;
                this.total_price_without_tax;
                // this.items_amount;
            },
            deep: true
        }
    },
    methods: {
        initCouponList: function() {
            let item_details = [];
            this.cart.forEach((val) => {
                item_details.push(val.hash)
            })
            // カートがない時はクーポンの取得を行わない
            if (this.cart.length === 0) {
                return;
            }
            let params = {
                'item_details': item_details,
                'is_pre_order': true
            };
            let url = this.route(this.route_list, 'site.api.cart.coupon.list');
            axios.get(url, {
                'params': params
            }).then(res => {
                    this.user_coupon_list = res.data.data.user_coupon_list;
                    this.is_logged_in = true;
            }).catch(error => {
                console.log(error);
                if (error.response.status === 403) {
                    this.user_coupon_list = [];
                } else {
                    this.modal_has_back = false;
                    this.user_coupon_list = [];
                    this.modal_title = 'クーポン情報取得'
                    this.modal_message = 'クーポンの情報取得に失敗しました。<br>ページを更新して下さい。'
                    this.openModal();
                }
            })
        },
        setItemPrice: async function () {
            this.is_loading.price = true;
            let url = this.route(this.route_list, 'site.api.item.detail', {
                'hash'   : this.item.hash,
                'coupon' : this.selected_coupon ? this.selected_coupon.activate_code : '',
                'isPreOrder' : true,
            });
            await axios.get(url, {
                params: {
                }
            }).then(res => {
                this.item_detail = res.data.data
                this.is_loading.price = false;
            }).catch(error => {
                this.is_loading.price = false;
            });
        },
        getCouponName: function(coupon_code) {
            let name = "";
            this.user_coupon_list.forEach(val => {
                if (val.TEMPORARY_COUPON_CODE === coupon_code) {
                    name = val.TEMPORARY_COUPON_CODE;
                }
            })
            return name;
        },
        crossOutPrice: function() {
            return this.selected_coupon
        },
        couponActivate() {
            this.modal_title = "クーポンが追加できません。";
            // 不要な通信はしない
            if(!this.input_coupon_code) {
                this.show_coupon_modal = true;
                this.modal_message = "クーポンコードが空です。"
                this.modal_has_back = true;
                this.openModal();
                return;
            }
            console.log(this.input_coupon_code);
            axios.post(this.route(this.route_list, 'site.api.coupon.activate'), {
                'COUPON_CODE': this.input_coupon_code
            }).then(res => {
                if (res.data.status === "ok") {
                    this.modal_title = "クーポンが追加されました。";
                    this.modal_message = '適用するにはクーポンの一覧から選択してください。';
                    this.input_coupon_code = "";
                    this.initCouponList();
                } else {
                    this.modal_message = 'クーポンのアクティベートに失敗しました。';
                }
            }).catch(error => {
                this.modal_message = error.response.data.errorMessage;
            }).finally( res => {
                this.modal_has_back = true;
                this.openModal();
            })
        },
        changeCoupon(item_hash, coupon_code, index) {
            this.changing_status = true;
            this.can_purchase;
            axios.post(this.route(this.route_list, 'site.api.cart.coupon.change'),
                {
                    item_hash: item_hash,
                    coupon_code: coupon_code,
                    is_pre_order: true,
                }
                ).then(res => {
                if (res.data.success === true) {
                    this.getCartItems();
                    this.coupon_list_status[index].is_open = false;
                    this.selected_coupon = coupon_code;
                } else {
                    this.cart[index].coupon_code = null;
                    this.modal_has_back = true;
                    this.modal_title = "クーポン変更";
                    this.modal_message = res.data.message;
                    this.openModal();
                }
            }).catch(error => {
                console.log(error);
            }).finally(res => {
                this.changing_status = false;
                this.can_purchase;
            });
        },
        openList: function(index) {
            this.coupon_list_status[index].is_open = !this.coupon_list_status[index].is_open
        },
        checkBackAction: function() {
            if (this.is_cart_waiting) {
                this.cancel_request();
                return
            } else {
                this.closeModal();
            }
        },
        openModal: function() {
            this.show_message_modal = true;
        },
        closeModal: function() {
            this.modal_cancel_button = null;
        },
        getCartItems(from_mounted = false) {
            axios.get(this.route(this.route_list, 'site.api.item.pre_order', {hash: this.item.hash, category: this.category})).then(res => {
                this.cart = res.data.data.cart;
                console.log(this.cart);
                if (from_mounted) {
                    this.cart.forEach((item, index) => {
                        let default_status = {
                            is_open: false,
                            is_loading: false,
                        }
                        this.coupon_list_status.push(default_status);
                    })
                    this.initCouponList(true);
                }
            }).catch(error => {
                console.log(error);
                this.modal_has_back = false;
                this.modal_title = '予約情報取得'
                this.modal_message = '予約情報取得に失敗しました。<br>ページを更新して下さい。'
                this.openModal();
            }).finally(res => {
                if (from_mounted) {
                    this.first_loading = false;
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.product-blocks {
    padding: 16px 15px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .product-block {
        display: grid;
        column-gap: 16px;
        grid-template-columns: 1fr 227px;
        grid-template-rows: min-content 1fr;
        grid-template-areas:
            "image info"
            "image price-detail";
        row-gap: 16px;
        padding-bottom: 16px;
        margin-bottom: 16px;

        @media (min-width: 768px) {
            grid-template-columns: 117fr 313fr 300fr;
            grid-template-rows: 1fr;
            grid-template-areas: "image info price-detail";
        }

        .warning {
            font-size: 12px;
            font-weight: 600;
            line-height: 130%;
            color: var(--gj-color-red);
        }

        .image-link {
            grid-row-start: span 2;

            img {
                grid-area: image;
                width: 100%;
                aspect-ratio: 102/155;
                object-fit: contain;
            }
        }

        .product-info {
            grid-area: info;
            font-weight: 600;
            display: flex;
            flex-direction: column;
            gap: 8px;

            .title {
                font-size: 20px;
                margin-bottom: 2px;
                line-height: 27px;
                word-break: break-all;
            }
            .model {
                font-size: 12px;
                margin-bottom: 2px;
                @media (min-width: 768px) {
                    font-size: 14px;
                }
            }
            .labels {
                display: flex;
                gap: 2px;
                &> c-label {
                    margin: 0;
                }
            }
        }
        .product-price-detail {
            grid-area: price-detail;
            display: grid;
            grid-template-columns: 100%;
            grid-template-rows: min-content min-content 1fr;
            --base-font-size: 12px;
            --first-column-size: 77px;

            @media (min-width: 768px) {
                --base-font-size: 13px;
                --first-column-size: 90px;
            }

            .price-grid-list {
                display: flex;
                flex-direction: column;
            }

            .price-grid {
                display: grid;
                grid-template-columns: var(--first-column-size) 61px 1fr;
                font-size: var(--base-font-size);
                font-weight: 300;
                margin-block: 4px;
                align-items: center;

                &:first-of-type {
                    margin-top: 0;
                }

                .c-label {
                    margin: 0;
                }

                .price {
                    text-align: right;
                }
                &.coupon {
                    grid-template-columns: 100%;
                    grid-template-rows: 1fr 25px;
                    row-gap: 2px;
                    -webkit-box-align: end;
                    align-items: end;
                }
            }
            .total-block {
                display: flex;
                justify-content: space-between;
                align-items: baseline;
                font-size: var(--base-font-size);
                font-weight: 300;
                margin-top: 8px;
                padding-top: 8px;
                border-top: 1px solid var(--gj-border-color);

                .total-price {
                    font-size: 20px;
                    font-weight: 600;
                    text-align: right;
                }
            }
            .delete-button-container {
                widows: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: flex-end;

                .delete-button {
                    font-size: 11px;
                    font-weight: 600;
                    line-height: 130%;
                    text-decoration-line: underline;
                }
            }
        }
    }
    .pre-order-price_text-grey {
        color: #566C7B;
    }
    .coupon-block {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 16px;

        @media (min-width: 768px) {
            padding: 24px 56px;
            background-color: #f9f9f9;
            flex-direction: row;
            gap: 56px;
        }

        .title {
            font-size: 16px;
            font-weight: 600;
            line-height: 130%;
            margin-bottom: 16px;
        }
        .note {
            font-size: 12px;
            font-weight: 300;
            line-height: 130%;
            color: var(--gj-text-color);
            margin-bottom: 8px;
        }

        .add-coupon {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: var(--gj-color-blue-bg);
            padding: 16px 24px;

            @media (min-width: 768px) {
                padding: 0;
                background-color: unset;
            }

            .add-form {
                display: flex;
                gap: 16px;
                flex-direction: column;
                width: 100%;

                input {
                    flex: 1 1 auto;
                }

                @media (min-width: 768px) {
                    gap: 8px;
                    flex-direction: row;
                }
            }
        }
        .all-coupon {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            @media (min-width: 768px) {
                align-items: center;
            }
        }
    }
}
.coupon-block {
    padding: 16px 15px;
    text-align: center;
    margin: auto;
}
.add-form {
    background-color: #E8F0F8;
    padding: 20px;
}
.add-form input {
    width: 100%;
    margin-top:10px;
    margin-bottom:15px;
}
.add-form p {
    text-align: left;
}
</style>
